import Loader from "components/Loader";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import authApi from "interceptor/authInterceptor";
import toast from "utils/ToastNotistack";

const DeputyCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const code = searchParams.get("code");

  useEffect(() => {
    const toastAndRedirectIfNotPopup = (success: boolean, message: string) => {
      if (window.opener) return;
      toast(message, { variant: success ? "success" : "error" });
      setTimeout(() => {
        navigate("/companyDetails/payrollSettings/view", { replace: true });
      }, 1200);
    };

    const run = async () => {
      if (!code) {
        toastAndRedirectIfNotPopup(false, "Authorization code is missing.");
        return;
      }

      const response: any = await authApi.get("/api/callback/deputy", {
        params: { code },
        skipErrorHandler: true,
      });

      if (response?.response?.data) {
        const msg =
          response.response.data?.message || "Failed to authenticate with Deputy.";
        toastAndRedirectIfNotPopup(false, msg);
      } else if (response?.data?.success) {
        const msg = response.data?.message || "Deputy connected successfully.";
        toastAndRedirectIfNotPopup(true, msg);
      } else {
        const msg = response?.data?.message || "Failed to authenticate with Deputy.";
        toastAndRedirectIfNotPopup(false, msg);
      }

      if (window.opener) {
        window.close();
      }
    };

    run();
  }, [code, navigate]);

  return <Loader />;
};

export default DeputyCallback;
